import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { handleLoadTrainingDetailsData } from 'modules/simulatorTrainings/common/slices/instructor'
import { ApiSimulatorTrainingScheduleResponse } from 'modules/simulatorTrainings/common/slices/instructor/types'
import { getSimulatorTrainingSchedule } from 'modules/simulatorTrainings/student/instructorLed/TrainingDetails/api/trainingDetailsService'
import { TrainingDetailsState } from './types'

const initialState: TrainingDetailsState = {
  scheduleDetailsData: {},
}

const trainingDetailsSlice = createSlice({
  name: 'simulatorTrainingStudentILTrainingDetails',
  initialState,
  reducers: {
    scheduleDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiSimulatorTrainingScheduleResponse>>
    ) {
      state.scheduleDetailsData = action.payload
    },
    clearScheduleDetailsData(state) {
      state.scheduleDetailsData = initialState.scheduleDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { scheduleDetailsLoaded } = trainingDetailsSlice.actions
export const { clearScheduleDetailsData } = trainingDetailsSlice.actions
export default trainingDetailsSlice.reducer

export const loadScheduleData = (scheduleId: Guid): ApiAction => {
  return createApiAction({
    apiCalls: {
      details: () => getSimulatorTrainingSchedule(scheduleId),
    },
    payloadAction: scheduleDetailsLoaded,
    nextAction: {
      action: handleLoadTrainingDetailsData,
      params: { payloadAction: scheduleDetailsLoaded },
    },
  })
}
